import moment from "moment";

const CancelledPartyBanner = ({ record }: { record: any }) => {
  if (record?.status !== "CANCELLED") return null;
  return (
    <div
      style={{
        backgroundColor: "#FEF2F2",
        border: "1px solid #FECACA",
        borderRadius: "8px",
        padding: "16px",
        marginBottom: "16px",
        display: "flex",
        gap: "12px",
        alignItems: "flex-start",
      }}
    >
      {/* Icon */}
      <div
        style={{
          width: "36px",
          height: "36px",
          borderRadius: "50%",
          backgroundColor: "#FEE2E2",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#DC2626",
          fontWeight: 700,
          fontSize: "18px",
          flexShrink: 0,
        }}
      >
        ✕
      </div>

      {/* Content */}
      <div style={{ flex: 1 }}>
        <div
          style={{
            fontSize: "16px",
            fontWeight: 600,
            color: "#991B1B",
            marginBottom: "8px",
          }}
        >
          Party Cancelled
        </div>

        <div
          style={{
            display: "flex",
            gap: "24px",
            flexWrap: "wrap",
            fontSize: "14px",
          }}
        >
          <div>
            <span style={{ color: "#7F1D1D", fontWeight: 500 }}>
              Cancelled At:
            </span>{" "}
            <span style={{ color: "#991B1B" }}>
              {record?.cancelledAt
                ? moment(record.cancelledAt).format(
                    "DD/MM/YYYY hh:mm A",
                  )
                : "-"}
            </span>
          </div>

          <div>
            <span style={{ color: "#7F1D1D", fontWeight: 500 }}>
              Reason:
            </span>{" "}
            <span style={{ color: "#991B1B" }}>
              {record?.cancellationReason || "Not provided"}
            </span>
          </div>

          {record?.cancellationSubReason && (
            <div>
              <span style={{ color: "#7F1D1D", fontWeight: 500 }}>
                Sub Reason:
              </span>{" "}
              <span style={{ color: "#991B1B" }}>
                {record.cancellationSubReason}
              </span>
            </div>
          )}

          {record?.cancelledBy && (
            <div>
              <span style={{ color: "#7F1D1D", fontWeight: 500 }}>Cancelled By:</span>{" "}
              {record?.cancelledByType === "ADMIN" ? (
                <a
                  href={`/#/AdminUsers/${record.cancelledBy}/show`}
                  style={{ color: "#DC2626", textDecoration: "underline" }}
                >
                  #{record.cancelledBy}
                </a>
              ) : record?.cancelledByType === "COOK" ? (
                <a
                  href={`/#/Cooks/${record.cancelledBy}/show`}
                  style={{ color: "#DC2626", textDecoration: "underline" }}
                >
                  #{record.cancelledBy}
                </a>
              ) : record?.cancelledByType === "CUSTOMER" ? (
                <a
                  href={`/#/Customers/${record.cancelledBy}/show`}
                  style={{ color: "#DC2626", textDecoration: "underline" }}
                >
                  #{record.cancelledBy}
                </a>
              ) : (
                <span style={{ color: "#991B1B" }}>#{record.cancelledBy}</span>
              )}
              {record?.cancelledByType && (
                <span style={{ color: "#6B7280", marginLeft: "6px", fontSize: "12px" }}>
                  ({record.cancelledByType})
                </span>
              )}
            </div>
          )}
        </div>

        <hr
          style={{
            border: 0,
            borderTop: "1px solid #FECACA",
            margin: "12px 0",
          }}
        />

        <div style={{ fontSize: "14px", color: "#991B1B" }}>
          {record?.refundMessage || "Not provided"}
        </div>

        {record?.lastMinuteCancellationMessage && (
          <div
            style={{
              fontSize: "14px",
              color: "#991B1B",
              marginTop: "8px",
            }}
          >
            {record.lastMinuteCancellationMessage}
          </div>
        )}
      </div>
    </div>
  );
};

export default CancelledPartyBanner;
